module.exports = __webpack_public_path__ + "img/fogg-delete-confirmation.79128744.svg";